export const workMap = {
  trackName__contains: '作品名(模糊)',
  trackName: '作品名(精确)',
  tmeTrackIdList: '作品ID',
  srcTrackName: '官方名称'
}

export { paymentMap } from '@/views/album/mixin'

export const singerMap = {
  singerName__contains: '艺人名(模糊)',
  singerName: '艺人名(精确)',
  singerId: '艺人ID',
}

export const albumMap = {
  albumName__contains: '专辑名(模糊)',
  albumName: '专辑名(精确)',
  tmeAlbumIdList: '专辑ID',
  srcAlbumName: '官方专辑名称'
}

export const statusMap = {
  0: '未审核',
  1: '已审核'
}

export const fromMap = {
  1: '优选生态平台',
  2: '编辑上传',
  // 3: '数字音乐平台',
}

export const userMap = {
  0: '未知',
  1: '合作公司',
  2: '免费授权',
  3: '优选公司B',
  4: '优选公司A',
  5: '优选公司C',
  // 6: '音乐人',
}

export const auditMap = {
  0: '未知',
  1: '版权变更',
  2: '版权下架',
  3: '版权认领'
}

export const cpDefectMap = {
  0: '无',
  1: '盗歌',
  2: '抄袭',
  3: '翻唱',
  4: '版权重叠',
  5: '无版权证明',
  6: '重复片段'
}

export const authTypeMap = {
  // 0: '请选择',
  1: '录音权',
  2: '词版权',
  3: '曲版权',
  4: '转授权',
  5: 'MV版权',
  6: '其他'
}

export const productMap = {
  1: '网易云音乐',
  2: '虾米音乐',
  3: '百度音乐',
  4: 'B站',
  5: '豆瓣音乐',
  6: 'Believe digital海外',
  7: '快手短视频',
  8: '字节跳动',
  9: 'apple',
  10: '唱吧',
  11: '唱吧直播间',
  12: '火星',
  13: '奶茶',
  14: 'VV音乐',
  15: '糖豆',
  16: '宇宙视频',
  17: '虾头',
  18: '美拍',
  19: '铃声多多',
  20: '今日头条',
  21: 'MOMO陌陌',
  22: '探探',
  23: '谁说',
  24: '超有梗',
  25: '哈你',
  26: '闪配',
  27: '映客直播',
  28: '老柚直播',
  29: '虎牙',
}

export const isOnlyMap = {
  0: '非首发',
  1: '首发',
  2: '无版权'
}

export const reviewStatusMap = {
  0: '待审核',
  1: '属实',
  2: '不属实',
  3: '商务认领',
  4: '补充材料'
}

export const updateMap = {
  1: '不更新',
  2: '人工处理',
  3: '直接生效'
}

export const appealTypeMap = {
  1: '版权变更',
  2: '下架',
  3: '认领'
}

export const hideReasonMap = {
  0: '用于有版权可播放歌曲',
  1: '用于无音频文件无法播放歌曲',
  2: '用于因重复上传下线歌曲',
  3: '用于音频文件不完整/异常歌曲',
  4: '用于网易独家歌曲',
  5: '用于阿里独家歌曲',
  6: '用于百度独家歌曲',
  7: '用于原平台迁移来的轻微版权问题歌曲',
  8: '用于版权方投诉需下线歌曲',
  9: '用于词曲版权方投诉需下线歌曲',
  10: '用于政府明确点名需下线用歌曲',
  11: '用于安全侧自查涉及敏感歌曲',
  12: '用于还未到发行/发售时间不可上线歌曲',
  13: '用于原平台迁移来的非正式发行歌曲',
  14: '用于原平台迁移来的GD提供歌曲',
  15: '用于原平台迁移来的不可使用的歌曲',
  16: '用于版权到期但未明确通知下线歌曲',
  17: '用于版权到期且明确通知需下线歌曲',
  18: '用于存在严重版权问题，版权方已进行诉讼歌曲 ，包括已取证未诉讼的',
  19: '明确点名下架内容，未来原本为10文化部通报的内容会逐步排查转移至此值',
  20: '用于存在盗用他人音源的歌曲，包括拼接片段组成歌曲的',
  21: '用于播客中心主播对账号进行注销操作而导致的账号下所有内容停用',
  22: '用于播客中心主播对专辑进行删除操作而导致的内容停用'
}

export const trackStatusMap = {
  0: '隐藏',
  1: '上架',
  2: '停用'
}

export const versionMap = {
  '-1': '未知',
  0: '完整版',
  1: 'Radio Edit',
  3: 'Live',
  4: 'TV Version',
  5: 'Demo',
  6: 'Remix',
  8: '伴奏',
  9: '语言版',
  10: 'LP版',
  11: 'Acoustic',
  12: 'Remaster',
  13: 'Revival',
  14: 'Clean',
  15: 'Explicit',
  16: 'Performance',
  17: 'Reprise',
  18: 'Jam Version',
  19: '纯音乐',
  20: 'Cast Version',
  21: 'Unplugged',
  22: '口白',
  23: 'Extended Version',
  26: 'MR',
  28: 'DJ版',
  29: 'Acappella',
  34: '翻唱版',
  35: 'Bonus Track',
  36: 'Orchestra',
  37: 'Album Version',
  38: 'Single Version',
  39: 'Rerecorded',
  40: '翻奏版',
  41: '地区版'
}

export const copyrightMap = {
  TRACK: '录音版权',
  WORD: '词版权',
  MUSIC: '曲版权',
}
